<template>
  <div>
    <button class="miniButton" @click="$emit('clickButton')">
      <span class="inner"><slot /></span>
    </button>
  </div>
</template>
<script>
export default {
  name: "MiniButton",
};
</script>
<style lang="scss" scoped>
.miniButton {
  $width: 100%;
  $height: 29px;
  $radius: 15px;
  width: $width;
  height: $height;
  color: $main-red;
  position: relative;
  overflow: hidden;
  border-radius: $radius;
  transition: color 0.3s $easing-color;
  transform: translate3d(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: $main-red;
    transform: translateY(101%);
    transition: transform 0.2s $easing-transition,
      border-radius 0.2s $easing-transition;
  }

  .inner {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
    border: 1px solid $main-red;
    border-radius: $radius;
    width: calc(#{$width} - 2px);
    height: calc(#{$height} - 2px);
  }

  svg {
    fill: currentColor;
    transition: fill 0.4s $easing-color;
  }

  .minibutton-text {
    font-size: 13px;
    position: relative;
    top: 1px;
  }

  @media (hover: hover) {
    &:hover {
      color: #fff;
      background-color: #fff;

      &::before {
        border-radius: $radius;
        transform: translateY(0);
      }
    }
  }

  @include media() {
    $radius: vw(15);
    $height: vw(24);
    height: $height;
    border-radius: $radius;

    .inner {
      height: calc(#{$height} - 2px);
      border-radius: $radius;
    }
    .minibutton-text {
      font-size: vw(10);
      top: 0;
    }

    @media (hover: hover) {
      &:hover {
        &::before {
          border-radius: $radius;
        }
      }
    }
  }
}
</style>
